import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';

function InfIndexEditor({ getControl, data }) {
  const mode = useMemo(
    () => (data.date === null ? 'byYear' : 'byDate'),
    [data.date],
  );
  return (
    <Grid container spacing={2}>
      {mode === 'byDate' && (
        <Grid item sm={6}>
          {getControl('date')}
        </Grid>
      )}
      {mode === 'byYear' && (
        <Grid item sm={6}>
          {getControl('year')}
        </Grid>
      )}
      <Grid item sm={6}>
        {getControl('percent')}
      </Grid>
    </Grid>
  );
}

InfIndexEditor.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
  }).isRequired,
  getControl: PropTypes.func.isRequired,
};

export default withBaseEditor(InfIndexEditor, '/api/catalog/inflationindex/', CommandPanels.catCommandPanel);
